<template>
  <grid-activity>
    <!-- extra button -->
    <template v-slot:primaryButton>
      <footer-button type="Add"></footer-button>
    </template>

    <!-- toolbars -->
    <template v-slot:additionalToolButtons>
      <b-btn aria-label="undo" variant="plm-toolbar-secondary" title="Undo">
        <font-awesome-icon icon="undo" />
      </b-btn>
      <b-btn aria-label="redo" variant="plm-toolbar-secondary" title="Redo">
        <font-awesome-icon icon="redo" />
      </b-btn>
    </template>

    <!-- GRID -->
    <data-grid2
        :items="lists"
        :columns="fields"
        ref="grid"
        :dblClickEnabled="true"

        v-model="selectedItem"
        :selectedIndex.sync="selectedIndex"

        @reload="refresh"
        :details-enable="permissions.ALL_BUSINESS_ENTITIES_READ"
        :add-enable="permissions.ALL_BUSINESS_ENTITIES_WRITE"
        :delete-enable="permissions.ALL_BUSINESS_ENTITIES_WRITE"
        :show-delete="true"
        :show-add="true"

        @details="editItem"
        @row-dblclicked="editItem"
        @delete="deleteItem"
        @add="addItem"
    > </data-grid2>

    <template v-slot:bottomLine>
      <!-- some extra CONTENT -->
      <b-container class="pt-1 px-2" fluid="true">
        <b-row no-gutters>
          <b-col>
            Some extra content
          </b-col>
        </b-row>
      </b-container>
      <!-- CONTENT END-->
    </template>


  <!-- FOOTER -->
    <template v-slot:footer>
      <!-- extra footer buttons -->
    </template>
  <!-- FOOTER END -->

  </grid-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FormHeader from "@/components/forms/FormHeader";
import FooterButton from "@/components/navbar/FooterButton";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import GridActivity from "@/activity/templates/layouts/GridActivity";

export default {
  name: "GridActivityTemplate",
  components: {GridActivity, DataGrid2, VBox, CloseButton, FooterNavbar, HeadersButtonGroup, FooterButton, FormHeader},
  permission: Perms.SUPERUSER,

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr('gridActivity','Grid Activity');
    },
    async canClose(){
      return true;
    },

    async editItem(){
      Log.debug("Wow!");
      await DialogManager.info($tr('editClicked','Edit clicked'),$tr('buttonClicked','Button was clicked') );
    },

    async addItem(){
      Log.debug("Wow!");
      await DialogManager.info($tr('newClicked','New clicked'),$tr('newButtonWasClicked','A new button was clicked') );
    },

    refresh(){
      // reload list
    },

    async deleteItem(){
      await DialogManager.info($tr('deleteClicked','Delete clicked'), $tr('deleteButtonWasClicked','A Delete button was clicked'));
    },

  },
  data:function(){return {
    selectedIndex:null,
    selectedItem:null,

    permissions: new PermissionsSet(),
    lists: [{'phone': "123"}, {'phone': "345"},{'phone': "123"}, {'phone': "345"},{'phone': "123"}, {'phone': "345"},{'phone': "123"}, {'phone': "345"},{'phone': "123"}, {'phone': "345"}],
    fields: [
      {name: 'rand', prop: 'rand', sortable: true},
      {
        name: 'Phone', prop: 'phone', autoSize: true, size: 110, sortable: true,
        template: "<div>XX {{model[prop]}} {{column}}</div>"
      }
    ],
  }}
}
</script>
